import { Box } from "@mui/material";
import { getKeyboardShortcutKeys, type KeyboardShortcut } from "src/utils/useKeyboardShortcut.ts";

interface KeyboardShortcutLabelProps {
	shortcut: KeyboardShortcut;
}

export function KeyboardShortcutLabel({ shortcut }: KeyboardShortcutLabelProps) {
	const keys = getKeyboardShortcutKeys(shortcut);

	return (
		<Box component={"span"} sx={{ display: "inline-flex", alignItems: "center", gap: 0.4 }}>
			{keys.map((key) => (
				<Box
					key={key}
					component={"kbd"}
					sx={{
						minWidth: 18,
						height: 18,
						paddingX: 0.5,
						border: "1px solid",
						borderColor: "divider",
						borderRadius: 0.5,
						backgroundColor: "background.paper",
						color: "text.primary",
						display: "inline-flex",
						alignItems: "center",
						justifyContent: "center",
						fontFamily: "inherit",
						fontSize: 11,
						fontWeight: 700,
						lineHeight: 1,
					}}
				>
					{key}
				</Box>
			))}
		</Box>
	);
}
